// getUserHot: https://gitlab.com/hapi_p/hapi/hapi-account-server/-/blob/main/app/ref/ref.class.php

// also need to update the NetworkIconMap src/constants/map.tsx
// also need to update the AVAILABLE_LEVELS src/constants/levels.ts
export enum Network {
  NEAR = "NEAR",
  BASE = "BASE",
  LINEA = "LINEA",
  BSC = "BSC",
  TON = "TON",
  SOLANA = "SOLANA",
  ARBITRUM = "ARBITRUM",
  STELLAR = "STELLAR",
  ETHEREUM = "ETHEREUM",
  // TESTNET
  TON_TESTNET = "TON_TESTNET",
}

export const NetworkChainMap = {
  [Network.TON]: -239,
  [Network.TON_TESTNET]: -3,
};
export const networksArray = Object.values(Network).filter((network) => {
  return !network.includes("TON_TESTNET");
});
